(function () {
  if (window.__buyNowButtonInitialized) {
    return;
  }

  window.__buyNowButtonInitialized = true;

  const BUY_NOW_HASH = '#jetzt-kaufen';
  const TARGET_SELECTORS = [
    '[data-buy-now-target]',
    '.product-information',
    '.product-information--inner',
    '#jetzt-kaufen',
    'variant-selects',
    '.variations',
    '.product-form',
    '#AddToCart'
  ];

  function isVisible(element) {
    return Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  function isBuyNowLink(link) {
    if (!link) {
      return false;
    }

    const href = link.getAttribute('href');

    if (!href) {
      return false;
    }

    if (href === BUY_NOW_HASH) {
      return true;
    }

    try {
      const url = new URL(link.href, window.location.href);

      return (
        url.hash === BUY_NOW_HASH &&
        url.origin === window.location.origin &&
        url.pathname === window.location.pathname &&
        url.search === window.location.search
      );
    } catch (error) {
      return false;
    }
  }

  function getScrollTarget() {
    for (const selector of TARGET_SELECTORS) {
      const target = document.querySelector(selector);

      if (isVisible(target)) {
        return target;
      }
    }

    return null;
  }

  function getHeaderOffset() {
    const rootStyles = window.getComputedStyle(document.documentElement);
    const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10);

    if (!Number.isNaN(headerHeight) && headerHeight > 0) {
      return headerHeight + 16;
    }

    const header = document.querySelector('#header');

    if (!header) {
      return 16;
    }

    return header.getBoundingClientRect().height + 16;
  }

  function scrollToTarget(target) {
    const targetTop = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function (event) {
    const targetElement = event.target instanceof Element ? event.target : null;
    const link = targetElement ? targetElement.closest('a') : null;

    if (!isBuyNowLink(link)) {
      return;
    }

    const target = getScrollTarget();

    if (!target) {
      return;
    }

    event.preventDefault();
    scrollToTarget(target);

    if (window.history && typeof window.history.replaceState === 'function') {
      window.history.replaceState(null, '', BUY_NOW_HASH);
    }
  });

  window.addEventListener(
    'load',
    function () {
      if (window.location.hash !== BUY_NOW_HASH) {
        return;
      }

      const target = getScrollTarget();

      if (!target) {
        return;
      }

      window.requestAnimationFrame(function () {
        scrollToTarget(target);
      });
    },
    { once: true }
  );
})();
